"use client";

import { useState } from "react";
import { flushSync } from "react-dom";

export interface VisibleErrors<Key extends string> {
  visible: (key: Key) => string | undefined;
  touch: (key: Key) => void;
}

export function useVisibleErrors<Key extends string>(
  errors: Partial<Record<Key, string>>,
) {
  const [touched, setTouched] = useState<ReadonlySet<Key>>(new Set());
  const [attempted, setAttempted] = useState(false);
  return {
    visible: (key: Key) => (attempted || touched.has(key) ? errors[key] : undefined),
    touch: (key: Key) => setTouched((current) => new Set(current).add(key)),
    attempt: () => flushSync(() => setAttempted(true)),
    hasErrors: Object.keys(errors).length > 0,
  };
}
